module.exports = require("xml");


//////////////////
// WEBPACK FOOTER
// external "xml"
// module id = 595
// module chunks = 0